import { createRouter, createWebHistory } from "vue-router";
import MemberPage from "./views/MemberPage.vue";
import ChangeMemberInfoPage from "./views/ChangeMemberInfoPage.vue";
import HomePage from "./views/HomePage.vue";
import CouponPage from "./views/coupon/CouponPage.vue";
import PointPage from "./views/PointPage.vue";
import PointExchangePage from "./views/PointExchangePage.vue";
import FormPage from "./views/FormPage.vue";
import BounsPage from "./views/BounsPage.vue";
import LotteryPage from "./views/LotteryPage.vue";
import StoragePage from "./views/StoragePage.vue";
import PromotionPage from "./views/PromotionPage.vue";
import DepositPage from "./views/DepositPage.vue";
import TicketPage from "./views/TicketPage.vue";
import MarketplacePage from "./views/MarketplacePage.vue";
import UseCouponPage from "./views/coupon/UseCouponPage.vue";
import StorePage from "./views/store/Store.vue";
import OrderPage from "./views/store/Order.vue";
import TableOrderPage from "./views/store/TableOrder.vue";
import PaymentPage from "./views/store/Payment.vue";
import OnlineOrderHistoryPage from "./views/orderHistory/OnlineOrderHistoryPage.vue";
import InStoreOrderHistoryPage from "./views/orderHistory/InStoreOrderHistoryPage.vue";
import StoreInfoPage from './views/StoreInfoPage.vue';
import InvitationPage from "./views/InvitationPage.vue";

import config from "./config.js";
import authGuard from "./routerAuth/general.guard";
import homePageAuthGuard from "./routerAuth/homePage.guard.js";
import memberPageGuard from "./routerAuth/memberPage.guard.js";
import orderPageGuard from "./routerAuth/order.guard.js";
import store from "./store/store";

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.redirectUri),
  routes: [
    { path: "/", component: HomePage, beforeEnter: homePageAuthGuard },
    // VIP卡首頁
    { path: "/:store", name: "memberInfo", component: MemberPage, beforeEnter: memberPageGuard },
    // 更改會員資料
    { path: "/:store/changeInfo", name: "changeMemberInfo", component: ChangeMemberInfoPage, beforeEnter: authGuard },
    // 優惠卷
    { path: "/:store/coupon", name: "coupon", component: CouponPage, beforeEnter: authGuard },
    // 使用優惠卷頁面
    /*
      method: claim => 領取優惠卷
              use => 使用優惠卷
    */
    { path: "/:store/coupon/:method/:id", name: "useCoupon", component: UseCouponPage },
    // 集點卡
    { path: "/:store/point", name: "point", component: PointPage, beforeEnter: memberPageGuard },
    // 兌換商品
    { path: "/:store/point/exchange", name: "pointExchange", component: PointExchangePage },
    // 問卷
    { path: "/:store/questionnaire", name: "form", component: FormPage },
    // 紅利積點
    { path: "/:store/bouns", name: "bouns", component: BounsPage },
    // 抽獎
    { path: "/:store/lottery", name: "lottery", component: LotteryPage },
    // 寄存紀錄
    { path: "/:store/deposit", name: "deposit", component: StoragePage },
    // 裂變活動
    { path: "/:store/invitation", name: "invitation", component: InvitationPage },
    // 行銷活動
    { path: "/:store/promotion", name: "promotion", component: PromotionPage },
    // 儲值信託
    { path: "/:store/trust", name: "trust", component: DepositPage },
    // 履約票卷
    { path: "/:store/ticket", name: "ticket", component: TicketPage },
    //黑貓商城
    { path: "/:store/marketplace", name: "marketplace", component: MarketplacePage},
    // 線上訂單記錄
    { path: "/:store/order-online", name: "onlineOrderHistory", component: OnlineOrderHistoryPage },
    // 門市訂單記錄
    { path: "/:store/order-in-store", name: "inStoreOrderHistory", component: InStoreOrderHistoryPage },
    // 商店資訊頁
    { path: "/:store/storeInfo", name: "storeInfo", component: StoreInfoPage },
    /* 
      線上點餐 
      orderMethod: dineIn => 輸入完桌號後跳至桌號點餐
                    takeOut => 外帶
                    pickUp => 自取
                    delivery => 外送
    */
    { path: "/:store/store/:orderMethod?", name: "onlineOrder", component: StorePage, beforeEnter: orderPageGuard },
    // 桌號點餐
    { path: "/:store/table/:areaId/:tableIndex?", name: "tableOrder", component: TableOrderPage, beforeEnter: orderPageGuard },
    /*
      點餐頁面 
      process: ordering => 選擇餐點
                orderConfirm => 確認訂單
                orderPayment => 付款
      method: dineIn => 輸入完桌號後跳至桌號點餐
              takeOut => 外帶
              pickUp => 自取
              delivery => 外送
      table: 桌號
    */
    { path: "/:store/:process/:method/:areaId/:tableIndex", name: "ordering", component: OrderPage, beforeEnter: orderPageGuard },
    /*
      確認訂單頁面 
      process: orderConfirm => 確認訂單
      method: dineIn => 輸入完桌號後跳至桌號點餐
              takeOut => 外帶
              pickUp => 自取
              delivery => 外送
      areaId: 區域ID
      tableIndex: 同區桌號index
    */
    { path: "/:store/:process/:method/:areaId/:tableIndex/:paymentType/:orderNumber", name: "payment", component: PaymentPage },
    /*
      付款頁面
      process: orderPayment => 付款
      method: dineIn => 輸入完桌號後跳至桌號點餐
              takeOut => 外帶
              pickUp => 自取
              delivery => 外送
      areaId: 區域ID
      tableIndex: 同區桌號index
      paymentType: 
        cash => 櫃檯付款
        linePay => Line Pay
      orderNumber: 訂單編號
    */
  ],
});

router.afterEach((to, from) => {
  window.gtag("config", config.gaKey, {
    page_path: from.page_path,
    page_location: to.location,
    page_title: to.title,
  });
});

router.beforeEach(async (to, from, next) => {
  store.commit("basic/setCurrentStore", to.params.store);
  window.document.title = '跨界VIP卡'
  next()
});

export default router;
